<template>
    <Loading v-if="loading" />
    <div v-else class="container">
       <div v-if="rightPerson == accusedPerson" class="right-container">
          <h2 class="header-text">
            YAY you're right!
          </h2>
       </div>
       <div v-else class="wrong-container">
           <h2 class="header-text">
            Oops you're wrong!
          </h2>
       </div>
       <div class="row-container">
        <div class="container">
            <div class='card'>
                <div class="front">
                    <img :src = "rightPersonDetails.picture" class="person-img" />
                    <p>{{rightPersonDetails.name}}</p>
                </div>
                <div class="back">
                    <p>{{rightPersonDetails.name}}</p>
                    <p>{{rightPersonDetails.description}}</p>
                </div>
            </div> 
        </div>
        <div class="description">
            <!--p>{{rightPersonDetails.name}} was the killer.</p>
            Reason: {{data.reason}}<p-->
            <p v-for ="(line,index) in output" :key = "index" >
                {{line}}
            </p>
               
        </div>
        </div>
        <button class="action-button" v-on:click="handleButtonClickNext">
            Try again
        </button>
    </div>
</template> 
<script>
import people from "../data/people.json"
import Loading from "./Loading.vue"
export default {
    name:'Result',
    components:{
        Loading
    },
    props:['accusedPerson'],
    data(){
        return {
            loading:true,
            data:{
                reason:"",
                isCorrect: false
            },
            rightPerson: "DR_GREEN",
            rightPersonDetails: people["people"]["DR_GREEN"],
            output: []
        }
    },
    created () {
        this.fetchData();
    },
    watch: {
        
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods:{
        handleButtonClickNext(){
            this.$router.push('/')
        },
        async fetchData () {
            /*
            let reason = "LOL NO REASON"
            if (this.accusedPerson == this.rightPerson){
                this.data = {
                    reason,
                    isCorrect:true
                }
            }  
            else {
                this.data = {
                    reason,
                    isCorrect:false
                }
            }
            */
           const names = ["FARMER_JONES", "MRS_ELLIS", "JOE_THOMPSON", "DR_GREEN"]
           const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ command: `accuse ${this.accusedPerson}` })
           }
           fetch("//104.154.83.191:8000/proxy", requestOptions)
            .then(async response => {
                var data = await response.json();
                console.log(data['result'])
                data['result'].forEach((item,index) => {
                    if (index == 1) {
                        let first = item.split(" ")[0].toUpperCase().replace('.','_')
                        let last = item.split(" ")[item.split(" ").length - 1].toUpperCase().replace('.','_')
                        console.log(first,last)
                        if (names.includes(first)){
                            this.rightPerson = first;
                            
                        }
                        else if (names.includes(last)){
                            this.rightPerson = last;
                        }
                    }
                    this.output.push(item);  
                    
                });
            })
            .catch(err=> console.log(err))
            this.loading = false;  
            console.log(this.output)
        
        }   
    }
}
</script>
<style>
.row-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top:2%
}
.right-container{
    width:100%;
    background-color:rgb(91, 194, 91);
    display:flex;
    justify-content: center;
    align-items: center;
    color:white
}
.wrong-container{
    width:100%;
    text-align: center;
    display:flex;
    background-color:#FF5C5C;
    align-items: center;
    justify-content: center;
    color:white
}
.description{
    font-size:28px;
    white-space: pre-line;
}   
.description-container{
    padding-left:4%;
    padding-right:4%;
}
.container {
  display:flex;
  align-items:center;
  justify-content: center;
  padding:2%;
  flex-direction: column;
}
.image-shark-final{
    width: 529px;
    height: 278px;
}
.image-container-final{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2%;
}
.header-text{
  font-size: 48px;
  width: 646px;
}
.card {
    display:flex;
    width: 100%;
    flex-direction: column;
    width: 360px;
    height: 360px;
    margin:2%;
    background: white;
    border-radius: 20px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: transform 0.8s;
    align-items: center;
    justify-content: center;
    transform-style: preserve-3d;
    perspective: 1000px;
    border: 4px solid transparent;
    
}   
.card:hover {
  box-shadow: 0 8px 16px 0 #FF5C5C;
  transform: rotateY(180deg);
  cursor: pointer;
}
.person-img {
    height:240px;
    width:240px;
}
.active {
    border-color: #FF5C5C;
}
/* Position the front and back side */
.front, .back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}


/* Style the back side */
.back {
  background-color: white;
  border-radius: 20px;
  transform: rotateY(180deg);
}
</style>